import type { LocalStorageContextProps } from '../Contexts/LocalStorageContext';
import type { UserContextProps } from '../Contexts/UserContext';

export function updateLastActivity(userContext: UserContextProps, localStorageContext: LocalStorageContextProps): void {
    
    const currentDate: Date = new Date();

    userContext.setLastActivity(currentDate);
    localStorageContext.localStorageService.setLastActivity(currentDate);
}